const Condition = require( './Condition' );

const SummonedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'summoned';
	condition.ConditionClass = SummonedCondition;

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};

SummonedCondition.fromCopy = function(cState, owner, instigator, battleState) {
	const elapsed = Date.now() - cState.startTime;
	const remainingDuration = Math.max(0, cState.duration - elapsed);
	return SummonedCondition(instigator, owner, battleState, remainingDuration);
};

module.exports = SummonedCondition
